import { TinyEmitter } from "@expert/event-bus";

import { RIGHT_TOP_TABS, isRightTopTab, type RightTopTab } from "@/sdk/agent/chat/rightTopTab";

// Re-exported so components keep importing the tab union/guard from here (the SDK owns the source).
export { RIGHT_TOP_TABS, isRightTopTab, type RightTopTab };

type SidecarTabEvents = {
    /** Bring a right-top tab to the front from outside Sidecar. */
    "focus-tab": RightTopTab;
};

/**
 * Lets imperative actions that live outside Sidecar's tree bring a right-top tab to the
 * front — e.g. the sales "Quick rebuttal" button, which pushes a message into the AI Assist timeline
 * and needs the AI Assist tab focused so the expert actually sees it.
 */
export const sidecarTabEventBus = new TinyEmitter<SidecarTabEvents>("sidecar-tab-events");
